import * as React from 'react';
export default function useForceUpdate() {
    const [, forceUpdate] = React.useReducer(x => x + 1, 0);
    return forceUpdate;
}
